import AREAS from './areas'
import CATEGORIA from './categoria'
import PRIORIDAD from './prioridad'

export class CambioEvaluacionDesempeñoNotification {
  #notification

  constructor(notification) {
    this.#notification = notification
  }

  create(args) {
    const notification = new this.#notification()
    notification.responsable = args.responsable
    notification.afectado = args.afectado
    notification.titulo = AREAS.DESARROLLO_POLICIAL + ': Cambio de evaluación de desempeño'
    notification.mensaje = args.mensaje
    notification.prioridad = PRIORIDAD.MEDIA
    notification.categoria = CATEGORIA.INFORMATIVA

    return notification
  }
}
